import type { ComponentType } from 'react';
import { loadRemote, registerRemotes } from '@module-federation/runtime';
import { mfeUrls } from './mfeUrls';

const isTestRuntime = () => {
  return process.env.NODE_ENV === 'test' || Boolean(import.meta.env.VITEST);
};

export const initializeModuleFederationRuntime = (): void => {
  if (isTestRuntime()) {
    return;
  }

  registerRemotes(
    Object.entries(mfeUrls).map(([name, entry]) => ({ name, type: 'module', entry })),
    { force: true }
  );
};

export const loadRemoteModule = async <TModule>(remoteId: string): Promise<TModule> => {
  if (isTestRuntime()) {
    return { default: () => null } as TModule;
  }

  const remoteModule = await loadRemote<TModule>(remoteId);

  if (!remoteModule) {
    throw new Error(`Failed to load MFE module "${remoteId}"`);
  }

  return remoteModule;
};

export const loadRemoteComponent = async <TProps = Record<string, never>>(
  remoteId: string
): Promise<{ default: ComponentType<TProps> }> => {
  return loadRemoteModule<{ default: ComponentType<TProps> }>(remoteId);
};
